var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaOffertwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6904_1238)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5985 12.9597V9.65819C21.5985 6.65483 19.0843 4.2146 15.9899 4.2146C12.8955 4.2146 10.3812 6.65483 10.3812 9.65819V12.9597H21.6099H21.5985ZM23.214 12.9597C24.2038 12.9597 25.0001 13.7326 25.0001 14.6932V24.2664C25.0001 25.2271 24.2038 26 23.214 26H8.75438C7.76462 26 6.96826 25.2271 6.96826 24.2664V14.6932C6.96826 13.7326 7.76462 12.9597 8.75438 12.9597H23.2026H23.214Z",
    fill: "#8A91A1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.78612 13.1695H20.8362C21.2116 13.1695 21.5074 13.4676 21.5074 13.821V23.096C21.5074 23.4604 21.2002 23.7475 20.8362 23.7475H6.78612C6.41069 23.7475 6.1149 23.4494 6.1149 23.096V13.821C6.1149 13.4566 6.42207 13.1695 6.78612 13.1695ZM20.8362 12.0874C21.8259 12.0874 22.6223 12.8603 22.6223 13.821V23.096C22.6223 24.0567 21.8259 24.8296 20.8362 24.8296H6.78612C5.79636 24.8296 5 24.0567 5 23.096V13.821C5 12.8603 5.79636 12.0874 6.78612 12.0874H20.8362Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8577 8.86318C19.8577 5.62794 17.1501 3 13.8167 3C10.4834 3 7.7644 5.62794 7.7644 8.86318V12.0874H8.87931V8.86318C8.87931 6.2242 11.0864 4.08209 13.8167 4.08209C16.5471 4.08209 18.7428 6.2242 18.7428 8.86318V12.0874H19.8577V8.86318Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5689 17.0342C15.5689 18.1825 14.6133 19.1211 13.4187 19.1211C12.2242 19.1211 11.2686 18.1935 11.2686 17.0342C11.2686 15.8748 12.2242 14.9473 13.4187 14.9473C14.6133 14.9473 15.5689 15.8748 15.5689 17.0342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7019 17.3875C12.7019 17.0011 13.0204 16.6919 13.4186 16.6919C13.8168 16.6919 14.1354 17.0011 14.1354 17.3875V21.7269C14.1354 22.1134 13.8168 22.4226 13.4186 22.4226C13.0204 22.4226 12.7019 22.1134 12.7019 21.7269V17.3875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6904_1238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 23,
    fill: "white",
    transform: "translate(5 3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaOffertwo);
export default __webpack_public_path__ + "static/media/PAOffertwo.992996d4f3f1855f8bfc9ba35ffbbc16.svg";
export { ForwardRef as ReactComponent };